export default {
  // 采集首页
  index: 'views/Index/Index',
  // 快速采集首页
  FastCollect: 'views/FastCollect/Index',
  // 快速采集详情页
  FastCollectDetail: 'views/FastCollect/Detail',
  // 快速采集配置页
  FastCollectConfig: 'views/FastCollect/Config',
  // 快速采集日志页
  FastCollectLog: 'views/FastCollect/CollectLog',
  // 自定义采集首页
  CustomCollect: 'views/CustomCollect/Index'
}
